export default __webpack_public_path__ + "static/media/TheWorldEngland_07.1d4aab88.png";